import {
  PERSONA_API_REQUEST, PERSONA_API_SUCCESS, PERSONA_API_ERROR
} from './actions';

export default function personaReducer(
  state = {
    traits: {}
  }, action
) {
  switch (action.type) {
    case PERSONA_API_REQUEST: {
      return { ...state, isLoading: true };
    }
    case PERSONA_API_SUCCESS: {
      return {
        ...state,
        traits: action.payload.traits,
        isLoading: false
      };
    }
    case PERSONA_API_ERROR: {
      return { ...state, error: true, isLoading: false };
    }
    default:
      return state;
  }
}
